export const VIDEO_EVENTS = {
  RECEIVE_CURRENT_TIME: 'receiveCurrentTime',
  REQUEST_CURRENT_TIME: 'requestCurrentTime',
};

export interface VideoPlayerHandle {
  getCurrentTime: () => Promise<number>;
}
